import { useEffect, useState } from "react";
import { ArrowLeft, UserCheck, Ticket, Gift, Wallet, Banknote, CreditCard, ShoppingBag } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const eur = (n) => `€${Number(n || 0).toFixed(2)}`;
const STATUS_CLS = { active: "bg-green-100 text-green-700", upcoming: "bg-amber-100 text-amber-700" };

function Stat({ icon: Icon, label, value, sub, testid }) {
  return (
    <div className="min-w-0 rounded-xl bg-white/10 px-1.5 py-2" data-testid={testid}>
      <Icon className="w-3.5 h-3.5 text-white/50 mb-0.5" />
      <p className="text-[9px] uppercase tracking-wide text-white/60 whitespace-nowrap">{label}</p>
      <p className="text-lg font-extrabold text-white leading-tight">{value}</p>
      {sub && <p className="text-[10px] text-white/60">{sub}</p>}
    </div>
  );
}

export default function DeskHeader({ event, eventId, refreshKey, onBack }) {
  const { authAxios } = useAuth();
  const [today, setToday] = useState(null);
  useEffect(() => {
    authAxios.get(`/accountant/events/${eventId}/today`).then(r => setToday(r.data)).catch(() => {});
  }, [eventId, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="rounded-2xl bg-[#1e3a5f] p-4 mb-4 text-white" data-testid="desk-header">
      <button onClick={onBack} className="flex items-center gap-1.5 text-white/70 hover:text-white text-sm mb-2" data-testid="desk-back-btn"><ArrowLeft className="w-4 h-4" /> All events</button>
      <div className="flex items-start justify-between gap-2">
        <h2 className="text-xl font-extrabold leading-tight" data-testid="desk-event-name">{event.name}</h2>
        <div className="flex gap-1 shrink-0">
          <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${STATUS_CLS[event.status] || "bg-slate-200 text-slate-600"}`}>{event.status?.toUpperCase()}</span>
          {event.settlement_status === "settled" && <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-blue-100 text-blue-700">SETTLED</span>}
        </div>
      </div>
      <p className="text-xs text-white/60 mb-3">{event.start_date} – {event.end_date}</p>
      {today && (
        <>
          <p className="text-[10px] uppercase tracking-widest text-white/50 mb-1">Today</p>
          <div className="grid grid-cols-5 gap-1" data-testid="today-strip">
            <Stat icon={UserCheck} label="Check-ins" value={today.checked_in} testid="today-checkins" />
            <Stat icon={Ticket} label="Walk-ins" value={today.walkins} testid="today-walkins" />
            <Stat icon={Gift} label="Coupons" value={today.coupons.count} sub={eur(today.coupons.amount)} testid="today-coupons" />
            <Stat icon={Wallet} label="Top-ups" value={today.topups.count} sub={eur(today.topups.amount)} testid="today-topups" />
            <Stat icon={ShoppingBag} label="Desk" value={today.desk_sales?.count || 0} sub={eur(today.desk_sales?.amount)} testid="today-desk" />
          </div>
          <p className="text-xs text-white/70 mt-2 flex flex-wrap items-center gap-x-3 gap-y-1" data-testid="today-mine">
            <span className="text-white/50">Collected by me:</span>
            <span className="flex items-center gap-1"><Banknote className="w-3.5 h-3.5" />{eur(today.mine.cash)} cash</span>
            <span className="flex items-center gap-1"><CreditCard className="w-3.5 h-3.5" />{eur(today.mine.card)} card</span>
          </p>
        </>
      )}
    </div>
  );
}
